module.exports = __webpack_public_path__ + "img/molmer-sorensen-dagger.5b32f46f.svg";